module.exports = __webpack_public_path__ + "img/pro_s1_icon4.0d478c7d.png";